/**
 * 🌟 TIER 11 BUILDINGS - Masterworks (End Game)
 * 
 * The ultimate structures. Victory conditions.
 * Cost multiplier: 9537x | Prod multiplier: 110x
 * Costs: 500,000-10,000,000 | Production: 50-110/s
 * Target ROI: ~45 minutes (prestige buildings)
 */

export const TIER_11_BUILDINGS = {
  fortress: {
    id: 'fortress',
    name: 'Fortress',
    icon: '🏰',
    tier: 11,
    description: 'Impenetrable military stronghold',
    flavor: 'A bastion against all threats.',
    baseCost: { stone: 750000, steel: 250000, tools: 125000 },
    baseProduction: { population: 55.0, gold: 33.0 },
    unlockCondition: { tech: 'tactics' },
  },

  grandCastle: {
    id: 'grandCastle',
    name: 'Grand Castle',
    icon: '🏰',
    tier: 11,
    description: 'Ultimate seat of power',
    flavor: 'A monument to your dynasty.',
    baseCost: { stone: 1000000, steel: 400000, gold: 500000, gems: 100000 },
    baseProduction: { population: 88.0, gold: 66.0, culture: 22.0 },
    unlockCondition: { tech: 'castle_construction' },
  },

  wonder: {
    id: 'wonder',
    name: 'Wonder of the World',
    icon: '🌟',
    tier: 11,
    description: 'A marvel that inspires all',
    flavor: 'In ages hence, scholars will speak of this with reverence.',
    baseCost: { stone: 1500000, steel: 500000, gold: 1000000, gems: 250000, magic: 125000 },
    baseProduction: { culture: 55.0, knowledge: 55.0, gold: 110.0 },
    unlockCondition: { tech: 'legendary_construction' },
  },

  arcaneNexus: {
    id: 'arcaneNexus',
    name: 'Arcane Nexus',
    icon: '🌀',
    tier: 11,
    description: 'Convergence of magical ley lines',
    flavor: 'Pure magical energy made manifest.',
    baseCost: { gems: 500000, magic: 250000, crystals: 125000, science: 250000 },
    baseProduction: { magic: 110.0, crystals: 33.0, artifacts: 22.0 },
    unlockCondition: { tech: 'ley_lines' },
  },

  eternalLibrary: {
    id: 'eternalLibrary',
    name: 'Eternal Library',
    icon: '📚',
    tier: 11,
    description: 'Contains all knowledge of the ages',
    flavor: 'Every truth ever discovered, preserved forever.',
    baseCost: { stone: 1250000, gold: 750000, knowledge: 500000, magic: 125000 },
    baseProduction: { knowledge: 55.0, science: 22.0, culture: 33.0 },
    unlockCondition: { tech: 'universal_knowledge' },
  },

  artifactForge: {
    id: 'artifactForge',
    name: 'Artifact Forge',
    icon: '⚗️',
    tier: 11,
    description: 'Creates powerful magical items',
    flavor: 'Where legends are forged.',
    baseCost: { stone: 400000, gems: 150000, magic: 100000, steel: 200000 },
    baseProduction: { artifacts: 22.0, magic: 55.0 },
    unlockCondition: { tech: 'artifact_crafting' },
  },

  dimensionalBeacon: {
    id: 'dimensionalBeacon',
    name: 'Dimensional Beacon',
    icon: '🌌',
    tier: 11,
    description: 'A transdimensional device to pierce the veil between universes',
    flavor: 'The path home... after all this time.',
    baseCost: { 
      stone: 2500000, 
      steel: 1000000, 
      gold: 2500000, 
      gems: 500000, 
      magic: 500000, 
      crystals: 250000, 
      artifacts: 150000,
      science: 250000 
    },
    baseProduction: {},  // No production - this is victory
    unlockCondition: { tech: 'beacon_construction' },
    isVictory: true,
    maxCount: 1,  // Can only build one
  },
};

export default TIER_11_BUILDINGS;
